import { useState } from 'react'
import { toast } from 'react-toastify'

import { deleteGroup as apiDeleteGroup } from '../../../../../services/group'

export function useGroup() {
  const [loading, setLoading] = useState(false)

  function deleteGroup(id: string, onSuccess?: () => void) {
    Promise.resolve()
      .then(() => setLoading(true))
      .then(() => apiDeleteGroup(id))
      .then(() => toast.info('O grupo foi excluído'))
      .then(() => onSuccess?.())
      .finally(() => setLoading(false))
  }

  return {
    loading,
    deleteGroup
  }
}
